module.exports = __webpack_public_path__ + "static/img/Arena-Champ-de-Mars-judo.9aca30f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Arena-Champ-de-Mars-judo.jpg
// module id = lwPz
// module chunks = 0